module.exports = __webpack_public_path__ + "static/media/virgina-mary.f2a5dd5c.png";